<template>
  <div>
    <div v-show="error" class="alert alert-danger" role="alert">{{ error }}</div>
    <div v-if="seats && seats.length">
      <p>There are {{ seats.length }} seats in this section.</p>
      <button
        class="btn btn-danger my-2"
        v-on:click="remove()"
      >Remove All</button>
    </div>
    <div v-else>
      <div v-for="(row, index) in rows" :key="index" class="form-group row">
        <label v-bind:for="'row-' + index" class="col-sm-4 col-form-label">Row {{ alphabet[index] }}</label>
        <div class="col-sm-3">      
          <input
            type="number"
            name="quantity"
            v-model="row.value"
            class="form-control"
            placeholder="Number of seats in row"
          >
        </div>
        <div class="col-sm-3">
          <button v-on:click="removeRow(index)" class="btn btn-danger">Remove</button>
        </div>
      </div>
      <button class="btn btn-secondary btn-block" v-on:click="addRow()">Add Row</button>
      <button class="btn btn-primary btn-block my-2" v-on:click="submit()">Submit</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section_id: null,
    seats: Array
  },

  data() {
    return {
      rows: [{ value: 8 }, { value: 8 }, { value: 8 }],
      alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
      error: null
    };
  },

  created() {},

  methods: {
    addRow() {
      this.rows.push({ value:8 });
    },
    removeRow(index) {
      this.rows.splice(index, 1);
    },
    submit() {
      this.resetError();
      axios
        .post("/event/seatfactory/" + this.section_id, {
          rows: this.rowsArray
        })
        .then(res => {
          if (res.data.ok) {
            this.setSeats(res.data.seats);
          } else {
            this.setError(res.data.error);
          }
        });
    },
    remove() {
      this.resetError();
      axios
        .delete("/event/seatfactory/" + this.section_id, {
          rows: this.rowsArray
        })
        .then(res => {
          if (res.data.ok) {
            this.setSeats([]);
          } else {
            this.setError(res.data.error);
          }
        });
    },
    setSeats(seats) {
      this.$emit("seats", seats);
    },

    setError(error) {
      this.error = error;
    },
    resetError() {
      this.error = null;
    }
  },

  computed: {
    rowsArray: function() {
      return this.rows.map(obj => obj.value);
    }
  }
};
</script>
